export const adminMenus = {
	'message.general': [{
			title: 'message.dashboard',
			action: 'zmdi-view-dashboard',
			// active: true,
			exact: true,
			items: null,
			path: '/dashboard',
			label: 'Old'
		},
		{
			action: 'zmdi-accounts',
			title: 'message.stores',
			// active: false,
			label: 'Old',
			path: '/stores',
			exact: true
		},
		{
			action: 'zmdi-local-shipping',
			title: 'message.deliveries',
			// active: false,
			label: 'Old',
			path: '/delivery-companies',
			exact: true
		},
		{
			action: 'zmdi-group-work',
			title: 'message.myCustomers',
			// active: false,
			label: 'Old',
			path: '/customers',
			exact: true
		},
		{
			action: 'zmdi-money',
			title: 'message.sales',
			// active: false,
			label: 'Old',
			path: '/license-sales',
			exact: true
		},

	]
}